import { FC, useEffect, useState } from 'react';
import { Tabs, Typography } from 'antd';
import { TbDatabase, TbUserScreen } from 'react-icons/tb';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

import Metadata from './meta';
import Overview from './views/01-Overview';
import ConnectedAccounts from './views/03-ConnectedAccounts';

// const { Link: AntDesignLink } = Anchor;

const General: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(false);
    }, []);

    const navigate = useNavigate();
    const url = '/settings/account/general';

    const onChangeTab = (newActiveKey: string) => {
        navigate(`${url}/${newActiveKey}`);
    };

    const items = [
        {
            label: (
                <>
                    <TbUserScreen size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.375rem' }} />
                    Overview
                </>
            ),
            key: 'overview',
            children: <Overview />,
        },
        {
            label: (
                <>
                    <TbDatabase size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.375rem' }} />
                    Data Sources
                </>
            ),
            key: 'connections',
            children: <ConnectedAccounts />,
        },
    ];

    const location = useLocation();

    const routeKey = location.pathname.split('/')[4];
    const activeKey = items.some((item) => item.key === routeKey) ? routeKey : 'overview';

    const { token } = useAntDesignTheme();

    return (
        <>
            <Metadata />

            <Typography.Title level={1} id='general'>
                General
            </Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary }}>
                View, manage, and update your account information here.
            </Typography.Paragraph>
            <Routes>
                <Route index element={<Navigate to={`${url}/overview`} replace />} />
                <Route path='authentication' element={<Navigate to='/settings/account/security' replace />} />
                <Route
                    path='*'
                    element={
                        <Tabs items={items} animated={true} activeKey={activeKey} size='small' onChange={onChangeTab} />
                    }
                />
            </Routes>
        </>
    );
};

export default General;
